import { render } from "./VODCardView.vue?vue&type=template&id=4c0cbcd0&scoped=true"
import script from "./VODCardView.vue?vue&type=script&lang=js"
export * from "./VODCardView.vue?vue&type=script&lang=js"

import "./VODCardView.vue?vue&type=style&index=0&id=4c0cbcd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c0cbcd0"]])

export default __exports__